import { useState } from "react";
import { FaPlus, FaMinus, FaSearch } from "react-icons/fa";

const faqData = [
  {
    question: "Is it safe to buy a car online?",
    answer: `We’d advise you to follow the same safety precautions when shopping online as you do in person. Do your research into the vehicle and the seller, check the documents, and get a vehicle history check.

    When doing anything online, you should keep your computer and security software up to date, use strong passwords, and check twice if anything looks too good to be true.

    Visit our safety and security centre for more.`,
  },
  {
    question: "When is the best time to buy a used car?",
    answer: `
There’s no fixed best time to buy a used car, but there are a couple of trends you should be aware of.

New cars are released in March and September, with many buyers trading their current car in. This means there tends to be more choice of used cars around this time, and there can be reduced prices as sellers compete.

Less in-demand models may have further price reduction in April and October, when sellers are keen to shift their unsold cars.
    `,
  },
  {
    question: "Are used cars reliable?",
    answer: `
One of the biggest fears when buying a used car is that it won’t last long. ZORQK perform a 5-point background check on every car listed on our site, so you can buy in confidence that it’s roadworthy and legal.

You can also perform a full vehicle check to ensure the used car is correctly priced and as described. As for the car itself, you can check our expert reviews to see how it performs for reliability, security and other key factors.`,
  },
  {
    question: "Can I test drive a used car?",
    answer: `
Test-driving is a great way to make sure a car meets your needs, and that it’s in a good condition. You can arrange a test drive when you contact the seller on ZORQK.

Make sure to check inside and outside the car, and be aware of any strange noises, vibrations or warning lights when you’re driving. For more information, here’s our guide on what to look for in a test drive.`,
  },
  {
    question: "Can I buy a used car online?",
    answer: `
You can browse used and nearly new cars available for home delivery on ZORQK. Simply enter your postcode and add ‘home delivery’ to your search, and we’ll help find the car that’s perfect for you. With more choice than anywhere else; helping people find their match, buying a car online is easy on ZORQK. Learn more about buying a car online.`,
  },
];

export default function FaqSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleIndex = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-10 px-4 text-primary">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-center text-[#1c2553] mb-10">
          Frequently asked questions
        </h2>

        {/* Search Bar */}
        {/* <div className="relative mb-10">
          <FaSearch className="absolute top-3.5 left-4 text-gray-400" />
          <input
            type="text"
            placeholder="Search Questions. . ."
            className="w-full border border-gray-300 rounded-full py-3 pl-12 pr-4 text-gray-700 focus:outline-none shadow-sm"
          />
        </div> */}

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqData.map((item, index) => (
            <div
              key={index}
              className="border border-gray-300 rounded-xl px-6 py-4"
            >
              <div
                className="flex items-center justify-between cursor-pointer"
                onClick={() => toggleIndex(index)}
              >
                <h4 className="font-bold text-[#1c2553] text-base md:text-lg">{item.question}</h4>
                {activeIndex === index ? (
                  <FaMinus className="text-gray-500" />
                ) : (
                  <FaPlus className="text-gray-500" />
                )}
              </div>
              {activeIndex === index && (
                <p className="mt-4 text-gray-600 text-sm md:text-base">{item.answer}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
